import { render, staticRenderFns } from "./customer-tier-form.vue?vue&type=template&id=8253fb40&scoped=true"
import script from "./customer-tier-form.vue?vue&type=script&lang=js"
export * from "./customer-tier-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8253fb40",
  null
  
)

export default component.exports